import { render, staticRenderFns } from "./ServerInformation.vue?vue&type=template&id=4b437138&"
import script from "./ServerInformation.vue?vue&type=script&lang=js&"
export * from "./ServerInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../whitelabel/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports